angular.module("app").factory("logger", [
    '$filter',
    'toastr',
    function ($filter, toastr) {
        var translate = $filter("translate");
        return {
            logSuccess: function (code) {
                toastr.success(translate(code))
            },
            logError: function (code) {
                toastr.error(translate(code))
            },
            logWarning: function (code) {
                toastr.warning(translate(code));
            }
        }
    }
]);

angular.module("app").factory("errorHandler", [
    'logger',
    '$rootScope',
    function (logger, $rootScope) {

        function handler (errorCode) {
            logger.logError(errorCode || "serverError")
        }

        $rootScope.$on("force:logout", function () {
            handler("Your session expired. You should login again")
        });
        return handler
    }
]);
